import { render, staticRenderFns } from "./galerii.vue?vue&type=template&id=bce5f568&"
import script from "./galerii.vue?vue&type=script&lang=js&"
export * from "./galerii.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports